module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/8-2a0930da1b816cbd3ca787179ecb3e5a.jpg";